import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      const resetScroll = () => {
        window.scrollTo(0, 0);
        if (window.lenis) window.lenis.scrollTo(0, { immediate: true });
      };
      
      resetScroll();
      // Retraso para compensar hidratación o componentes lentos
      const timeout = setTimeout(resetScroll, 100);
      return () => clearTimeout(timeout);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;